import { api } from './api';

const cardBalancesGetList = async (params) => {
    const response = await api({
        url: `CardBalances/getList`,
        method: 'GET',
        params,
    });
    return response.data;
};

const cardBalancesDownloadFile = async (data) => {
    const response = await api({
        url: `CardBalances/downloadCardBalanceFile`,
        method: 'POST',
        data,
        responseType: 'blob',
    });
    return response.data;
};

const cardBalancesServices = {
  cardBalancesGetList,
  cardBalancesDownloadFile,
};

export default cardBalancesServices;
